/*
 * 全局事件总线
 */

import Event from 'events';

const evtBus = new Event();

export default evtBus;